import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CardHolderNameService {

  validName(cardHolderName: string): boolean {
    const name = cardHolderName.split(' ')
    if (name.length === 2) {
      return !(/^[a-zA-Z- ]+$/g.test(name[0]) && /^[a-zA-Z- ]+$/g.test(name[1]));
    } else {
      return true
    }
  }
}
